<!-- 公共头部 -->
<template>
  <div class="header-wrapper">
    <el-row style="min-width: 670px">
      <div style="float: left; width: 300px">
        <div class="header">
          <img src="../../assets/img/logo.svg" alt="" @click="goIndex" />
        </div>
      </div>
      <div style="float: right; width: 600px">
        <el-row class="control">
          <div class="menu" :class="{ active: current == 2 }">
            <div>
              <el-dropdown>
                <span class="el-dropdown-link">
                  <i class="el-icon-user-solid"></i>
                  <span>{{ userName }}</span>
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <span @click="goUser">
                    <el-dropdown-item><span>个人权益</span></el-dropdown-item>
                  </span>
                  <span @click="goUserCenter">
                    <el-dropdown-item><span>个人中心</span></el-dropdown-item>
                  </span>
                  <!-- <span @click="goUserMoney">
                    <el-dropdown-item><span>个人酬金</span></el-dropdown-item>
                  </span> -->
                  <span @click="exit()">
                    <el-dropdown-item><span>退出</span></el-dropdown-item>
                  </span>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="menu" :class="{ active: current == 1 }">
            <div @click="goIndex"><i></i><span>进入平台</span></div>
          </div>
          <div class="menu" :class="{ active: current == 4 }">
            <div @click="goBuy">
              <i
                class="el-icon-shopping-cart-2"
                style="font-size: 16px; margin-right: 5px; color: #fff"
              ></i
              ><span>咨询与购买</span>
            </div>
          </div>
          <div class="menu" :class="{ active: current == 3 }">
            <div @click="goApp"><i></i><span>下载</span></div>
          </div>
          <div class="menu" :class="{ active: current == 5 }">
            <div @click="goHome"><i></i><span>产品</span></div>
          </div>
        </el-row>
      </div>
    </el-row>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  data() {
    return {
      current: 1, // 当前选中的头部菜单
      userName: null, // 用户名称
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.path.indexOf("/index") != -1) {
          this.current = 1;
        } else if (val.path.indexOf("/user") != -1) {
          this.current = 2;
        } else if (val.path.indexOf("/app") != -1) {
          this.current = 3;
        } else if (val.path.indexOf("/pricing") != -1) {
          this.current = 4;
        } else if (val.path.indexOf("/home") != -1) {
          this.current = 5;
        }
      },
      //初始化时监听
      immediate: true,
      // 深度观察监听
      deep: true,
    },
  },
  created() {
    let userInfo = this.$cookies.get("userInfo");
    if (userInfo && userInfo.name) {
      this.userName = userInfo.name;
    }
  },
  computed: {},

  methods: {
    ...mapMutations(["setLoginStatus"]),
    // 前往首页
    goIndex() {
      this.current = 1;
      this.$router.push("/index");
    },
    goBuy() {
      this.current = 4;
      this.$router.push("/pricing");
    },
    goUser() {
      this.current = 2;
      this.$router.push("/user");
    },
    goApp() {
      this.current = 3;
      this.$router.push("/app");
    },
    goHome() {
      this.current = 5;
      this.$router.push("/home");
    },

    /*退出账户*/
    exit: function () {
      this.setLoginStatus({
        status: false,
      });
      this.$message({
        message: "退出成功",
        type: "success",
      });
      this.$cookies.remove("tokenWeb");
      this.$cookies.remove("userInfo");
      this.$cookies.remove("tokenWebRefresh");
      this.$cookies.remove("tokenWeb", "/", "ringdata.com");
      this.$cookies.remove("userInfo", "/", "ringdata.com");
      this.$cookies.remove("tokenWebRefresh", "/", "ringdata.com");

      //先清除，防止账号切换时，isRequestor未更新
      this.$cookies.remove("isRequestor");
      setTimeout(() => {
        this.$router.push("/login");
      }, 500);
    },

    // 前往个人中心
    goUserCenter() {
      this.current = 2;
      window.open("https://i.ringdata.com/index");
    },

    // 前往个人酬金
    // goUserMoney () {
    //   this.current = 2
    //   this.$router.push('/commission')
    // },
  },
};
</script>

<style lang="scss" scoped>
.header-wrapper {
  height: 60px;
  width: 100%;
  background: #3c82a8;
  padding: 0px 0px 0px 20px;
  .header {
    line-height: 60px;
    img {
      cursor: pointer;
      height: 42px;
      vertical-align: middle;
    }
    span {
      cursor: pointer;
      color: #f1f1f1;
      font-size: 20px;
    }
  }
  .control {
    line-height: 60px;
    .menu {
      padding: 0 20px;
      text-align: center;
      cursor: pointer;
      float: right;
    }
    .active {
      background-color: #206184;
    }
    span {
      color: #f1f1f1;
    }
  }
}
</style>
 


// WEBPACK FOOTER //
// src/components/common/header.vue